import { render } from "./ScanSupplierCode.vue?vue&type=template&id=5606ae42"
import script from "./ScanSupplierCode.vue?vue&type=script&lang=js"
export * from "./ScanSupplierCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__